import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle, FaBirthdayCake } from "react-icons/fa";
import { IoCalendarOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';


export default function Home() {
    const navigate = useNavigate();
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [sections, setSections] = useState([]);
    const [userData, setUserData] = useState({});
    const [clubEvents, setClubEvents] = useState([]);
    const [calendarArray, setCalendarArray] = useState([]);

    const [pageLoading, setPageLoading] = useState(true);

    useEffect(() => {
        console.log('cook', cookies);
        getData();
    }, [])

    async function getData() {
        setPageLoading(true)
        try {
            const response = await axios.get(base_url + '/home.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    memberno: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            if (response.data.status) {
                setUserData({name: response.data.data.name, age: response.data.data.member_age, member_type: response.data.data.member_type, id: response.data.data.section_id, section_fee: response.data.data.section_fee, renewal_date: response.data.data.renewal_date, member_image: response.data.data.member_image, member_no: response.data.data.member_no })
                setSections(response.data.data.member_sections);
                setClubEvents(response.data.data.club_events);
                setCalendarArray(response.data.data.calendar_array)
            } else {

            }
            setPageLoading(false)
        } catch (error) {
          setPageLoading(false)
        }
    }

    // const sections = [
    // {
    //     id: "001",
    //     name: "Tennis",
    //     fee: "₦50,000 / year",
    //     dueDate: "2025-12-31",
    // },
    // {
    //     id: "002",
    //     name: "Swimming",
    //     fee: "₦35,000 / year",
    //     dueDate: "2025-11-15",
    // },
    // {
    //     id: "003",
    //     name: "Golf",
    //     fee: "₦120,000 / year",
    //     dueDate: "2026-01-20",
    // },
    // {
    //     id: "004",
    //     name: "Cultural",
    //     fee: "₦20,000 / year",
    //     dueDate: "2025-09-30",
    // },
    // ]

  return (
    <div className="flex flex-col">
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#000080'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#000080] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, ${userProfile?.name}`} />
        <div className="px-6 grid md:grid-cols-2 gap-4 pb-6">
            <div
              className="bg-white p-4 rounded shadow"
            >
              <div className="flex flex-col items-center pt-6">
                <img
                  src={userData?.member_image || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQF02Jj8T2t7PdkytAw42HDuuSz7yXguKn8Lg&s'}
                  className="w-20 h-20 object-cover rounded-full border-4 border-gray-200 mb-3"
                />
                <h3 className="text-lg font-semibold">{userData?.name}</h3>
                <span className="text-sm text-gray-500">
                  Membership No. {userData?.member_no}
                </span>
                <span className="text-sm text-gray-500">
                  {userData?.member_type}
                </span>
              </div>
              <div className="text-center space-y-3 pb-2">
                <p className="text-sm text-gray-600">{userData?.member_age}</p>
                <div
                  className={`inline-flex items-center gap-2 px-4 py-1 rounded-full text-sm font-medium ${'text-[#00b47a]'} ${'bg-[#bcffeaff]'}`}
                >
                  <FaRegCheckCircle className="w-4 h-4" />
                  {'Active'}
                </div>
              </div>
              <div className="text-center space-y-3 pb-4">
                <button onClick={() => navigate('/dashboard/edit-profile')} className="bg-[#000080] text-[#7ace90] rounded-[5px] py-2 px-4">Edit Profile</button>
              </div>
            </div>
            <div className="bg-white p-4 rounded shadow">
                <h3 className="font-semibold mb-2">My Sections</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                    {sections?.map((section) => (
                    <div key={section.section_id} className="rounded-[7px] border border-1 hover:cursor-pointer transition">
                        <div className="flex flex-col items-center space-y-2 pt-3">
                            <h3 className="text-lg font-semibold">{section.section}</h3>
                        </div>
                        <div className="text-center space-y-3 pb-4">
                        <div className="flex items-center justify-center gap-2 text-gray-700">
                            <span className="font-medium">{section.section_fee}</span>
                        </div>
                        <div className="flex items-center justify-center gap-2 text-gray-700">
                            <IoCalendarOutline className="w-4 h-4 text-red-600" />
                            <span className="text-sm">Next Due: {section.renewal_date}</span>
                        </div>
                        </div>
                    </div> 
                    ))}
                </div>
                {sections?.length < 1 && (
                  <div className="w-full h-[-webkit-fill-available] flex items-center justify-center">
                    <div className="rounded-[7px]">
                        <div className="flex flex-col items-center">
                            <h3 className="text-lg font-semibold">{'No Sections Joined'}</h3>
                            <span className="text-sm">Contact membership office</span>
                        </div>
                    </div>
                  </div>
                )}
            </div>
            <div className="bg-white p-4 rounded shadow">
                <h3 className="font-semibold mb-2">Upcoming Events</h3>
                <p className="font-regular mb-4 text-sm">Events this month</p>
                <div className="flex flex-col gap-y-2 h-[300px] overflow-y-auto">
                    {clubEvents?.map((event, index) => (
                        <div className={`w-[max-content] px-3 py-2 ${event.section == "birthday" ? 'bg-[#ffbfe1]' : 'bg-gray-200'} rounded-[5px] flex flex-row items-center gap-x-3`}>{event.section == 'birthday' ? <FaBirthdayCake /> : <IoCalendarOutline />}<p className="text-sm">{event.event_title} – {event.event_date}</p></div>
                    ))}
                </div>
            </div>
            <div className="bg-white p-4 rounded shadow">
                <h3 className="font-semibold mb-2">Events Calendar</h3>
                <EventCalendar 
                    calendarArray={calendarArray}
                />
            </div>
        </div>
    </div>
  );
}
